import {
  QA_GET_OFFERS_LISTING,
  QA_GET_OFFERS_LISTING_SUCCESS,
  QA_GET_OFFERS_LISTING_FAILED,
  QA_OFFER_EDIT,
  QA_OFFER_EDIT_SUCCESS,
  QA_OFFER_EDIT_FAIL,
  QA_OFFER_UPDATE,
  QA_OFFER_UPDATE_SUCCESS,
  QA_OFFER_UPDATE_FAIL,
} from "./actionTypes"

const initialState = {
    error: null,
    loading: false,
    msg: null,
    offer: [],
    offerEdit: null,
    offerUpdate: null,
  }

  const qaOffer = (state = initialState, action) => {
    switch (action.type) {
      case QA_GET_OFFERS_LISTING:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offer: action.payload,
        }
        break
      case QA_GET_OFFERS_LISTING_SUCCESS:
        state = { ...state, error: null,  msg: null, loading: false, offer: action.payload }
        break
      case QA_GET_OFFERS_LISTING_FAILED:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case QA_OFFER_EDIT:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offerEdit: action.payload,
        }
        break
      case QA_OFFER_EDIT_SUCCESS:
        if (state === null || state.offer.length === 0) {
          state = {
            ...state,
            loading: false,
            error: null,
            msg: null,
            offer: [...state.offer, action.payload],
          }
        } else {
          state = {
            ...state,
            loading: false,
            error: null,
            msg: null,
            offer: state.offer.map(i =>
              i.offer_id === action.payload.offer_id ? action.payload : i
            ),
          }
        }
        break
      case QA_OFFER_EDIT_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
      case QA_OFFER_UPDATE:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          offerUpdate: action.payload,
        }
        break
      case QA_OFFER_UPDATE_SUCCESS:
        state = { ...state, error: null,  msg: null, loading: false }
        break
      case QA_OFFER_UPDATE_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
        break
    }
    return state
  }

  export default qaOffer